import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["innerHTML"]

import feather, { FeatherIconNames } from "feather-icons";
import { computed, SVGAttributes } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FeatherIcon',
  props: {
  icon: {
    type: String,
    required: true
  },
  size: {
    type: String,
    default: "24",
    validator: (s: string) =>
      !Number.isNaN(s) ||
      (s.length >= 2 &&
        !Number.isNaN(s.slice(0, s.length - 1)) &&
        s.slice(-1) === "x")
  }
},
  emits: ["click"],
  setup(__props, { emit: emits }) {

const props = __props;



const size = computed(() =>
  props.size.slice(-1) === "x"
    ? props.size.slice(0, props.size.length - 1) + "em"
    : `${parseInt(props.size, 10)}px`
);

const icon = computed(() => feather.icons[props.icon as FeatherIconNames]);

const svgAttrs = computed(() => {
  const attrs = {
    ...icon.value.attrs,
    width: size.value,
    height: size.value
  };
  return attrs as SVGAttributes;
});

const html = computed(() => icon.value.contents);



return (_ctx: any,_cache: any) => {
  return (icon.value)
    ? (_openBlock(), _createElementBlock("svg", _mergeProps({ key: 0 }, svgAttrs.value, {
        innerHTML: html.value,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('click')))
      }), null, 16, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})